import { Component } from '@theme/component';

let swiperPromise = null;

function loadSwiper(jsUrl, cssUrl) {
  if (window.Swiper) return Promise.resolve();
  if (swiperPromise) return swiperPromise;

  swiperPromise = new Promise((resolve, reject) => {
    if (cssUrl && !document.querySelector('link[data-swiper-css]')) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = cssUrl;
      link.dataset.swiperCss = '';
      document.head.append(link);
    }

    const existing = document.querySelector('script[data-swiper-js]');
    if (existing) {
      existing.addEventListener('load', resolve);
      existing.addEventListener('error', reject);
      return;
    }

    const script = document.createElement('script');
    script.src = jsUrl;
    script.dataset.swiperJs = '';
    script.addEventListener('load', resolve);
    script.addEventListener('error', reject);
    document.head.append(script);
  });

  return swiperPromise;
}

class SimucubeConfiguratorRail extends Component {
  #swiper;

  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    this.#init();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
    this.#destroy();
  }

  refresh() {
    this.#swiper?.update();
  }

  get #track() {
    return this.querySelector('.sc-cfg-step__grid');
  }

  async #init() {
    if (this.#swiper) return;

    const host = this.closest('[data-swiper-js]');
    if (!(host instanceof HTMLElement) || !host.dataset.swiperJs) return;

    try {
      await loadSwiper(host.dataset.swiperJs, host.dataset.swiperCss);
    } catch {
      return;
    }

    const track = this.#track;
    if (!window.Swiper || this.#swiper || !this.isConnected || !(track instanceof HTMLElement)) return;

    this.addEventListener('click', this.#blockClickAfterDrag, { capture: true, signal: this.#abortController.signal });

    this.classList.add('swiper');
    track.classList.add('swiper-wrapper');
    for (const card of track.children) card.classList.add('swiper-slide');

    this.#swiper = new window.Swiper(this, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      speed: 350,
      followFinger: true,
      grabCursor: true,
      threshold: 6,
      noSwipingSelector: 'input, select, option, textarea, video',
      focusableElements: 'input, select, option, textarea, video',
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true, releaseOnEdges: true, thresholdDelta: 6 },
      breakpoints: {
        990: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, spaceBetween: 12 },
      },
    });
  }

  #blockClickAfterDrag = (event) => {
    if (this.#swiper && !this.#swiper.allowClick) event.stopPropagation();
  };

  #destroy() {
    if (!this.#swiper) return;

    this.#swiper.destroy(true, true);
    this.#swiper = undefined;

    this.classList.remove('swiper');
    this.#track?.classList.remove('swiper-wrapper');
    for (const card of this.querySelectorAll('.swiper-slide')) card.classList.remove('swiper-slide');
  }
}

if (!customElements.get('sc-config-rail')) {
  customElements.define('sc-config-rail', SimucubeConfiguratorRail);
}
